import styled from 'styled-components'
import {seaNavy, white} from '@modifi/colors'

import Link from '../../../features/common/link'
import {STYLE_CONSTANTS} from '../../../styles'
import {Small} from '../../../styles/typography'

export const Wrapper = styled.article`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  background: ${seaNavy};
  color: ${white};
  transform: translateY(200%);
  transition: transform 0.5s ease;
  ${({isVisible}) => isVisible && 'transform: translateY(0);'}
  z-index: 200;

  button {
    text-transform: capitalize;
    padding: 0 30px;

    + button {
      margin-left: 30px;
    }
  }
`

export const StyledSmall = styled(Small)`
  a {
    color: ${white} !important;
    font-weight: 600;
  }
`

export const StyledLink = styled(Link)`
  font-weight: ${STYLE_CONSTANTS.FONT_WEIGHT_BOLD};
  text-decoration: underline;
`
